module.exports = __webpack_public_path__ + "img/chiku07.d9ee397d.png";